import { getCountry } from '@iwIntlProvider/CountryProvider';

import { ApprovedViewDE } from './DE/ApprovedViewDE';
import { FlexiApprovedPage } from './FlexiApprovedPage';

export const ApprovedView = () => {
    if (getCountry() === 'DE') {
        return <ApprovedViewDE />;
    }

    return <FlexiApprovedPage />;
};
